import { getCurrency } from '@rushplay/session'

import { getBrandCurrency } from '../store/app'

export default function getPlayerCurrency(state) {
  return getCurrency(state.session) || getBrandCurrency(state)
}
